export default __webpack_public_path__ + "static/media/iq-kr.f6adba3a.svg";